import React, { useCallback } from 'react';
import * as userService from '../../services/userService';
import { Role } from '../../entities/role.entity';

const useUsers = () => {
    const [loading, setLoading] = React.useState(false);


    const getUser = useCallback((userId: string) => {
        return userService.getDetailUser(userId);
    }, []);

    const assignRoleToUser = useCallback(
        async (userId: string, roleIds: string[]): Promise<void> => {
            if (!userId) {
                return;
            }
            await userService.assignRoles(userId, roleIds);
        },
        []
    );

    const assignPermissionToUser = useCallback(
        async (userId: string, permissionIds: string[]): Promise<void> => {
            if (!userId) {
                return;
            }
            await userService.assignPermissions(userId, permissionIds);
        },
        []
    );

    return {
        getUser,
        assignPermissionToUser,
        assignRoleToUser
    };
};

export default useUsers;
